module.exports = __webpack_public_path__ + "assets/SettingsBtnWhite.5ef78200d1f01dd84e2ef85b76ffbdf0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/buttons/SettingsBtnWhite.svg
// module id = 861
// module chunks = 0